// extracted by mini-css-extract-plugin
export default {"card":"language_card__6m60p"};